import React, { Fragment, useContext, useEffect } from 'react';
import { Grid, Button, Paper, Typography } from '@material-ui/core';
import { useStyles } from '../styles/Styles';
import Success from '../components/success/Success';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import Spinner from '../components/spinner/Spinner';
import Header from '../components/header/Header';

const Acknowledgement = () => {
  const classes = useStyles(); //Use Styles from styles/styles.js
  const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
  const {
    userInfo,
    noOfUploadedDocs,
    noOfRequiredDocs,
    noOfSubmittedDocs,
    doneProcess,
    submitDocuments,
    errors,
    nextStep,
  } = documentUploadContext;

  const today = new Date();
  var months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  useEffect(() => {
    console.log(noOfRequiredDocs);
    if (noOfSubmittedDocs >= noOfRequiredDocs) {
      submitDocuments(userInfo.referenceNumber);
    }
    // eslint-disable-next-line
    // eslint-disable-line react-hooks/exhaustive-deps
    // eslint-disable-next-line
  }, [noOfSubmittedDocs, noOfRequiredDocs]); // eslint-disable-next-line
  useEffect(() => {
    if (errors === 'error') {
      nextStep(2);
    } // eslint-disable-next-line
    // eslint-disable-line react-hooks/exhaustive-deps
    // eslint-disable-next-line
  }, [errors]); // eslint-disable-next-line

  console.log(doneProcess);
  return (
    <div>
      <Header page={4} />
      <div className={classes.banner}>
        <Paper elevation={3} className={classes.acknowledgementpaper}>
          {noOfSubmittedDocs >= noOfRequiredDocs && doneProcess > 0 ? (
            <Fragment>
              <Success severity={'success'} />
              <Grid container spacing={8}>
                <Grid item xs={8} sm={4}>
                  <p className={classes.acknowledgementHeaders}>
                    Reference Number
                  </p>
                  <Typography>
                    {userInfo.referenceNumber}
                    {/* {referenceNumber} */}
                    <br />
                  </Typography>
                </Grid>
                <Grid item xs={8} sm={4}>
                  <p className={classes.acknowledgementHeaders}>
                    Date and Time Submitted
                  </p>
                  <Typography>{`${
                    months[today.getMonth()]
                    }  ${today.getDate()}, ${today.getFullYear()}  ${formatAMPM(
                      new Date()
                    )}`}</Typography>
                </Grid>
                <Grid item xs={8} sm={4}>
                  <p className={classes.acknowledgementHeaders}>
                    Number of Documents Submitted
                  </p>
                  <Typography className={classes.noOfUploadedDocs}>
                    {noOfRequiredDocs}
                    <br />
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                direction='row'
                justify='center'
                alignItems='center'
              >
                <Grid item md={2}>
                  <Button
                    className={classes.acknowledgementButton}
                    variant='contained'
                    color='primary'
                    href='/'
                  >
                    Back to Home Page
                  </Button>
                </Grid>
              </Grid>
            </Fragment>
          ) : (
              <h1>
                <Spinner />
              </h1>
            )}
        </Paper>
      </div>
    </div>
  );
};

export default Acknowledgement;
